<template>
    <div id="annual">
        <img src="./../../assets/annual/2.png" alt="" class="img1">
        <img src="./../../assets/annual/1.png" alt="" class="img2">
        <div class="info">
            <h1>活动期间仅需</h1>
            <h2><b>365</b> 元</h2>
            <h3>立即成为包年会员，全站书籍免费畅读</h3>
            <p>今日购买额外赠送2个月！先到先得</p>
        </div>
        <p class="btn"><button @click="doRecharge">立即订购</button></p>
        <img src="./../../assets/annual/3.png" alt="" class="img3">
    </div>
</template>

<script>
    export default {
        name: "Annual",
        data(){
            return {
                active:1,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 10,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#annual{
    min-height: 1500px;background-color: #000;overflow: auto;position: relative;
    img{width: 100%;}
    .img2{position: relative;top: -250px;width: 90%;margin: 0 auto;display: block;}
    .img3{}
    .info{width: 94%;border:4px solid #f6df9d;margin:-180px auto 0;text-align: center;color: #f6df9d;
        h1{font-weight: 400;line-height: 130px;font-size: 64px;}
        h2{
            b{font-size: 90px;}
        }
        h3{font-weight: 300;margin-bottom: 20px;font-size: 38px;}
        p{color: #fff;font-size: 30px;margin-bottom: 20px;}
    }
    .btn{text-align: center;margin-top: 100px;
        button{background: #f6df9d;color: #000;    padding: 10px 80px;font-size: 36px;border-radius: 12px;}
    }
}
</style>
